import type {SearchableColumn, SearchableColumnType} from 'src/types/byod';

/**
 * Normalize `table_config.searchable_columns` into `{key, label, type}` filter
 * fields — keeps only entries with a usable string key and falls back to the
 * key when an entry carries no label. Kept as a small pure helper so ByodTable
 * stays declarative and the mapping is unit-testable.
 */
export function resolveSearchableColumns(
  searchable: SearchableColumn[] | undefined,
): {key: string; label: string; type: SearchableColumnType}[] {
  if (!searchable || searchable.length === 0) {
    return [];
  }
  const result: {key: string; label: string; type: SearchableColumnType}[] = [];
  for (const col of searchable) {
    if (!col || typeof col.key !== 'string' || col.key.length === 0) {
      continue;
    }
    result.push({key: col.key, label: col.label || col.key, type: col.type});
  }
  return result;
}
